import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { EnrollmentDetail } from '../../models/en-details'
import { EmailAddressTextFieldValidator } from '../../../validations/email-address-text-field-validator'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { ValidatedSelectOptionModel as State } from '../../../validations/validated-dropdown.component'
import { ActivatedRoute, Params } from '@angular/router'
import { Router } from '@angular/router'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { StateGateway } from '../../../common/gateways/state-gateway'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'EnrollmentApplicationClient',
    templateUrl: 'enrollment-application-client.component.html'
})

export class EnrollmentApplicationClientComponent implements OnInit {

    disabled: boolean
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    emailValidator = new EmailAddressTextFieldValidator()
    @Input() enDetail: EnrollmentViewModel = {} as EnrollmentViewModel
    states: State[]
    selAuthorizedRep: string
    selAppointmentRep: string
    id: string
    public rblAuthorizedRep: ValidatedRadioButtonModel[] = []
    public rblAppointmentRep: ValidatedRadioButtonModel[] = []
    public rblMailCopy: ValidatedRadioButtonModel[] = []
    @Output() onValueChange: EventEmitter<EnrollmentViewModel> = new EventEmitter<EnrollmentViewModel>()
    hideAgree: boolean = true
    isAuthRep: boolean
    rblRelation: ValidatedSelectOptionModel[] = []
    statusInProg: boolean = false
    orgName: string
    visibleFrom2025: boolean
    public rblAppIndIND: ValidatedRadioButtonModel[] = []

    constructor(private route: ActivatedRoute, private router: Router,
        private _stateGateway: StateGateway, public _global: PortalGlobals) {

    }

    // constructor() {
    //    this.rblAuthorizedRep.push({ value: 'No', htmlLabel: 'No' }, { value: 'Yes', htmlLabel: 'Yes' })
    // }
    ngOnInit() {
        this.isAuthRep = false
        this.getParams();
        if (this.id === "3") {
            this.hideAgree = false
        }
        if (this.id === "1") {
            this.disabled = true
        }
        else {
            this.disabled = false
        }
        this.rblRelation.push(
            { value: 'Aunt', text: 'Aunt' },
            { value: 'Brother', text: 'Brother' },
            { value: 'Caretaker', text: 'Caretaker' },
            { value: 'Case Worker', text: 'Case Worker' },
            { value: 'Companion', text: 'Companion' },
            { value: 'Cousin', text: 'Cousin' },
            { value: 'Daughter', text: 'Daughter' },
            { value: 'Daughter In Law', text: 'Daughter In Law' },
            { value: 'Father', text: 'Father' },
            { value: 'Father In Law', text: 'Father In Law' },
            { value: 'Friend', text: 'Friend' },
            { value: 'Grand Daughter', text: 'Grand Daughter' },
            { value: 'Grand Son', text: 'Grand Son' },
            { value: 'Home Provider', text: 'Home Provider' },
            { value: 'Hospice', text: 'Hospice' },
            { value: 'Husband', text: 'Husband' },
            { value: 'Mother In Law', text: 'Mother In Law' },
            { value: 'Mother', text: 'Mother' },
            { value: 'Nephew', text: 'Nephew' },
            { value: 'Niece', text: 'Niece' },
            { value: 'Power of Attorney', text: 'Power of Attorney' },
            { value: 'Program Coordinator', text: 'Program Coordinator' },
            { value: 'Other', text: 'Other' },
            { value: 'Residential Support', text: 'Residential Support' },
            { value: 'Son In Law', text: 'Son In Law' },
            { value: 'Sister', text: 'Sister' },
            { value: 'Son', text: 'Son' },
            { value: 'Social Worker', text: 'Social Worker' },
            { value: 'Step Daughter', text: 'Step Daughter' },
            { value: 'Step Son', text: 'Step Son' },
            { value: 'Wife', text: 'Wife' },
            { value: 'Spouse', text: 'Spouse' }
        )
        //this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        //if (this.enrollment !== undefined) {
        //    this.selectedPlan = this.enrollment.PLANNAME
        //    this.rblAuthorizedRepClick(this.enrollment.AUTHREPIND)
        //    if (this.enrollment.SUBMISSIONTYPECODE === 'INCOMPLETE') {
        //        this.showTermsButton = false
        //    } else {
        //        this.showTermsButton = true
        //    }
        //}
        //this.rblAuthorizedRep.push(
        //    {
        //        value: 'No', htmlLabel: 'No', disabled: this.disabled
        //    },
        //    {
        //        value: 'Yes', htmlLabel: 'Yes', disabled: this.disabled
        //    })

        this.rblAppointmentRep.push(
            {
                value: 'Yes',
                htmlLabel: 'I completed a Scope of Appointment and I will submit it separately.',
                disabled: !this.disabled

            },
            {
                value: 'No',
                htmlLabel: 'A Scope of Appointment was NOT completed because I did not '
                    + 'have an individual or one-on-one marketing appointment (whether in person, telephonically or otherwise) '
                    + 'with the applicant.',
                disabled: !this.disabled

            })
        this.rblAuthorizedRep.push({
            value: 'No', htmlLabel: 'No',
            disabled: this.disabled
        }, {
                value: 'Yes', htmlLabel: 'Yes',
                disabled: this.disabled
            })
        this.rblMailCopy.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        //this._stateGateway.getAllStates().subscribe(
        //    (states: State[]) => this.states = states
        //)

        this.states = [
            { "value": "AL", "text": "Alabama" },
            { "value": "AK", "text": "Alaska" },
            { "value": "AZ", "text": "Arizona" },
            { "value": "AR", "text": "Arkansas" },
            { "value": "CA", "text": "California" },
            { "value": "CO", "text": "Colorado" },
            { "value": "CT", "text": "Connecticut" },
            { "value": "DE", "text": "Delaware" },
            { "value": "DC", "text": "District of Columbia" },
            { "value": "FL", "text": "Florida" },
            { "value": "GA", "text": "Georgia" },
            { "value": "HI", "text": "Hawaii" },
            { "value": "ID", "text": "Idaho" },
            { "value": "IL", "text": "Illinois" },
            { "value": "IN", "text": "Indiana" },
            { "value": "IA", "text": "Iowa" },
            { "value": "KS", "text": "Kansas" },
            { "value": "KY", "text": "Kentucky" },
            { "value": "LA", "text": "Louisiana" },
            { "value": "ME", "text": "Maine" },
            { "value": "MD", "text": "Maryland" },
            { "value": "MA", "text": "Massachusetts" },
            { "value": "MI", "text": "Michigan" },
            { "value": "MN", "text": "Minnesota" },
            { "value": "MS", "text": "Mississippi" },
            { "value": "MO", "text": "Missouri" },
            { "value": "MT", "text": "Montana" },
            { "value": "NE", "text": "Nebraska" },
            { "value": "NV", "text": "Nevada" },
            { "value": "NH", "text": "New Hampshire" },
            { "value": "NJ", "text": "New Jersey" },
            { "value": "NM", "text": "New Mexico" },
            { "value": "NY", "text": "New York" },
            { "value": "NC", "text": "North Carolina" },
            { "value": "ND", "text": "North Dakota" },
            { "value": "OH", "text": "Ohio" },
            { "value": "OK", "text": "Oklahoma" },
            { "value": "OR", "text": "Oregon" },
            { "value": "PA", "text": "Pennsylvania" },
            { "value": "PR", "text": "Puerto Rico" },
            { "value": "RI", "text": "Rhode Island" },
            { "value": "SC", "text": "South Carolina" },
            { "value": "SD", "text": "South Dakota" },
            { "value": "TN", "text": "Tennessee" },
            { "value": "TX", "text": "Texas" },
            { "value": "UT", "text": "Utah" },
            { "value": "VT", "text": "Vermont" },
            { "value": "VI", "text": "Virgin Islands" },
            { "value": "VA", "text": "Virginia" },
            { "value": "WA", "text": "Washington" },
            { "value": "WV", "text": "West Virginia" },
            { "value": "WI", "text": "Wisconsin" },
            { "value": "WY", "text": "Wyoming" }]

        if (this.enDetail.historyStatus === 'In Progress' || this.enDetail.historyStatus === 'Correction') {
            this.statusInProg = true
        }
        this.setOrgname()
       
    }

    valueChanged(bAgree: boolean) {
        this.enDetail.BGCHECK = bAgree
        this.onValueChange.emit(this.enDetail)
    }

    getParams() {
        this.route.params.forEach((params: Params) => {
            this.id = this.route.snapshot.params['id']
        })
    }
    rblAuthorizedRepClick(event: any): void {
        if (event === 'Yes') {
            this.isAuthRep = true
        } else {
            this.isAuthRep = false
        }
        this.enDetail.AUTHREPIND = event
    }
    setOrgname() {
        if (this._global.selectedPlanYear === 0 || this._global.selectedPlanYear === undefined) {
            if (sessionStorage.getItem("PLANYEAR") !== undefined) {
                this._global.selectedPlanYear = Number(sessionStorage.getItem("PLANYEAR"))
            }
        }
        if (Number(this._global.selectedPlanYear) === this._global.CurrentYear) {
            this.orgName = 'SilverScript'
        }
        else {
            this.orgName = 'Aetna'
        }
    }

  
}
